import React, { useRef, useState } from 'react';
import Barcode from 'react-barcode';
import './barcode.css';

const BarcodeGenerator = () => {
  const printRef = useRef();
  const [itemId, setItemId] = useState('');
  const [itemName, setItemName] = useState('');
  const [quantity, setQuantity] = useState('1');
  const [generated, setGenerated] = useState(null);

  const handleGenerate = () => {
    if (itemId && itemName && quantity) {
      setGenerated({ item_id: itemId, item_name: itemName, quantity });
    }
  };

  const handleNativePrint = () => {
    const printContent = printRef.current;
    const WindowPrt = window.open('', '', 'width=600,height=600');
    WindowPrt.document.write(`
      <html>
        <head>
          <title>Print Barcode</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
            .barcode-card { border: 1px solid #ccc; padding: 16px; border-radius: 6px; display: inline-block; }
            .barcode-title { font-weight: bold; margin-bottom: 6px; font-size: 16px; }
            .barcode-meta { font-size: 13px; margin-top: 6px; color: #333; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  };

  return (
    <div className="barcode-generator-wrapper">
      <h2>Custom Barcode Generator</h2>

      <div className="barcode-form">
        <input
          type="text"
          placeholder="Item ID (value for barcode)"
          value={itemId}
          onChange={(e) => setItemId(e.target.value)}
        />
        <input
          type="text"
          placeholder="Item Name"
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
        />
        <input
          type="number"
          placeholder="Quantity"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
        />
        <button className="barcode-btn-generate" onClick={handleGenerate}>Generate Barcode</button>
      </div>

      {generated && (
        <div className="barcode-preview" ref={printRef}>
          <div className="barcode-card">
            <div className="barcode-title">{generated.item_name}</div>
            <Barcode
              value={generated.item_id}
              format="CODE128"
              width={1.5}
              height={50}
              fontSize={12}
              displayValue={true}
            />
            <div className="barcode-meta">Qty: {generated.quantity}</div>
          </div>
        </div>
      )}

      {generated && (
        <div className="barcode-toolbar">
          <button className="barcode-btn-print" onClick={handleNativePrint}>Print Barcode</button>
        </div>
      )}
    </div>
  );
};

export default BarcodeGenerator;
